import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { withGlobalSearch } from '~/entities/catalog/url-search';

const searchSchema = withGlobalSearch({
  sub: z.string().optional(),
  item: z.string().optional(),
  child: z.string().optional(),
});

/** Legacy `/categories/:cat/subcategories/:sub` → `/categories/:cat/:sub`. */
export const Route = createFileRoute('/categories_/$categoryId/subcategories/$subcategoryId')({
  validateSearch: searchSchema,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/categories/$categoryId/$subcategoryId',
      params: {
        categoryId: params.categoryId,
        subcategoryId: params.subcategoryId,
      },
      search,
      replace: true,
    });
  },
});
